import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ServiceUsagesGroup_Update_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ServiceUsagesGroup_Update(
      $isOptional: Boolean
      $label: String!
      $serviceUsagesGroupId: Id!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      updateMissionServiceUsagesGroup(
        isOptional: $isOptional
        label: $label
        serviceUsagesGroupId: $serviceUsagesGroupId
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useUpdateMissionServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ServiceUsagesGroup_Update_Mutation,
  );
